// extracted by mini-css-extract-plugin
module.exports = {"truncatedText":"WithTruncatedTooltip_truncatedText__ek4xg"};